/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { RegionsFormResponse } from '@/account/types';
import { Region, RegionTransform } from '../models';

export const transformRegions = (
  response: RegionsFormResponse
): RegionTransform[] | [] => {
  const availableRegions = response?.data?.country?.available_regions;
  if (!availableRegions) return [];

  const regions = availableRegions
    .filter((item) => {
      if (!item) return false;

      const { id, code, name } = item;
      return Boolean(id && code && name);
    })
    .map((region) => {
      const { id } = region as Region;

      return { id, text: region.name, value: `${region.code},${region.id}` };
    });

  return regions;
};
